export const getConnectorsStatuses = t => {
   return {
   active: { label: t("active"), displayName: t("active"), classname: "on", isLoadingStatus: false },
   inactive: { label: t("inactive"), displayName: t("inactive"), classname: "warning", isLoadingStatus: false },
   pending: { label: t("pending"), displayName: t("pending"),  classname: "loading", isLoadingStatus: true },
   failed: { label: t("failed_to_launch"), displayName: t("failed"), classname: "failed", isLoadingState: false },
   unknown: { label: t("unknown"), displayName: t("unknown"), classname: "unknown", isLoadingState: false }
};
}

export const getAgentValidationStatuses = t => {
   return {
      SUCCESS: { label: t("success"), displayName: t("success") },
      IN_PROGRESS: { label: t("in_progress"), displayName: t("in_progress") },
      FAILED: { label: t("failed"), displayName: t("failed") }
   };
}
